'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { ProjectsTableSkeleton } from './ProjectsTableSkeleton';

export function ProjectsPageSkeleton() {
  return (
    <div className="p-4 lg:p-6">
      {/* KPI strip skeleton (4 cards) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="border rounded-lg bg-card p-4 space-y-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-7 w-16" />
          </div>
        ))}
      </div>

      {/* Sticky filter bar skeleton */}
      <div className="sticky top-[calc(var(--header-height,72px)+10px)] z-30 -mx-4 px-4 lg:-mx-6 lg:px-6 py-3 mb-4 bg-background/80 backdrop-blur-md border-b">
        <div className="flex flex-col lg:flex-row gap-3">
          {/* Search pill */}
          <Skeleton className="h-9 lg:w-100 rounded-md" />

          <div className="flex flex-wrap items-center gap-2">
            {/* CFP segmented control */}
            <Skeleton className="h-8 w-28 rounded-md" />
            {/* Country filter */}
            <Skeleton className="h-8 w-24 rounded-md" />
            {/* Organisation filter */}
            <Skeleton className="h-8 w-32 rounded-md" />
            {/* Sector filter */}
            <Skeleton className="h-8 w-24 rounded-md" />
            {/* Sort */}
            <Skeleton className="h-8 w-32 rounded-md" />
          </div>
        </div>
      </div>

      {/* Table skeleton */}
      <ProjectsTableSkeleton rows={7} />
    </div>
  );
}
